import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { ApolloLink, Operation, NextLink } from '@apollo/client/core';

export const successInterceptor = (
    toastrAlertService: ToastrService,
) => {
    return new ApolloLink((operation: Operation, forward: NextLink) => {
        return forward(operation).map((response) => {
            const isMutation = operation.query.definitions.some(
                (def: any) => def.kind === 'OperationDefinition' && def.operation === 'mutation'
              );
              console.log("Respuesta:", response);
            const isSuccess = response.data && !response.errors;
            if (isMutation && isSuccess) {
                toastrAlertService.success('¡Operación completada con éxito!');
            }
            return response;
        });       
    })
}